import { pushRoute } from '../../../lib/router.js';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Col, Grid, Row } from 'react-bootstrap';
import { Form } from 'react-final-form';
import { getOrgTermsContent } from '../../../content/utils.js';
import { getOrgSlug, mapFinalFormErrors } from '../../../lib/utils.js';
import StepMilestonesFrom from '../../../components/portfolio/EditPortfolioForms/StepMilestonesForm.jsx';
import {
  deletePortfolio,
  finishUpdatePortfolioDraft,
  selectPortfolioDraft,
  selectPortfolioDraftId,
  updatePortfolioDraft,
} from '../../../modules/portfolio.js';
import {
  navigateToStepDetails,
  navigateToStepLinkedFiles,
  onCreateUpdateCancel,
  onReset,
} from './utils/index.js';
import PortfolioHeader from '../../../components/headers/PageHeaders/Portfolio/PortfolioHeader.jsx';
import MultistepCombinedHeader from '../../../components/headers/FormHeaders/MultistepCombinedHeader.jsx';

const mapErrors = mapFinalFormErrors('Failed to save change strategy');

const randomId = () => Math.random().toString(36).slice(2, 7);

const mapStateToProps = (state, ownProps) => ({
  editing: !!ownProps.portfolioId,
  portfolioId: ownProps.portfolioId,
  draftId: selectPortfolioDraftId(state),
  portfolioDraft: selectPortfolioDraft(selectPortfolioDraftId(state))(state),
});

const mapDispatchToProps = {
  updatePortfolioDraft,
  finishUpdatePortfolioDraft,
  deletePortfolio,
};

function StepMilestonesFormContainer({
  editing,
  draftId,
  portfolioId,
  portfolioDraft,
  deletePortfolio,
  updatePortfolioDraft,
  finishUpdatePortfolioDraft,
}) {
  const [entities, setEntities] = useState([]);
  const [loading, setLoading] = useState(false);

  const goBack = () =>
    navigateToStepDetails(editing, portfolioId, getOrgSlug());
  const goNext = () =>
    navigateToStepLinkedFiles(editing, portfolioId, getOrgSlug());
  const onCancel = () =>
    onCreateUpdateCancel(draftId, deletePortfolio, getOrgSlug());

  const onCreateMilestone = () => {
    setEntities([
      ...entities,
      {
        tempId: randomId(),
        name: '',
        notes: '',
        date_at: null,
      },
    ]);
  };
  const onFieldChange = (index, key, val) => {
    setEntities((prevState) => {
      const newState = [...prevState];
      newState[index] = { ...newState[index], [key]: val };
      return newState;
    });
  };

  const onDeleteMilestone = (key, val) => {
    if (!window.confirm('Are you sure you want to delete this milestone?'))
      return;

    setEntities((prevState) => prevState.filter((item) => item[key] !== val));
  };

  const onSubmit = (values) => {
    const { finish } = values;

    const draft = {
      milestones: entities,
    };

    const submitPromise = finish
      ? finishUpdatePortfolioDraft(draftId, draft, true)
      : updatePortfolioDraft(draftId, draft);

    return submitPromise
      .then(({ result }) =>
        finish
          ? pushRoute('portfolio/show/info', { portfolioId: result })
          : goNext()
      )
      .catch(mapErrors);
  };

  const validate = () => {
    const errors = {};

    if (entities.length) {
      entities.forEach((item, index) => {
        if (!item.name) errors[`name${index}`] = "Can't be blank";
        if (item.name && !item.date_at)
          errors[`date_at${index}`] = "Can't be blank";
      });
    }

    return errors;
  };

  useEffect(() => {
    if (portfolioDraft && !entities.length) {
      setEntities(portfolioDraft.milestones);
    }
  }, [portfolioDraft]);

  useEffect(() => {
    !portfolioDraft && onReset(editing, portfolioId, getOrgSlug());
  }, []);

  return (
    <React.Fragment>
      <MultistepCombinedHeader
        editing={editing}
        subject={getOrgTermsContent('portfolio')}
        typeStep="Milestones"
      >
        <PortfolioHeader portfolio={portfolioDraft} editing={editing} />
      </MultistepCombinedHeader>
      <Grid>
        <Row>
          <Col sm={12}>
            <div className="component-xl component-bg-white component-xl-padding-vertical component-no-horizontal-padding">
              <Row>
                <Col sm={10} smOffset={1}>
                  <Form
                    validate={validate}
                    entities={entities}
                    onCreateMilestone={onCreateMilestone}
                    onFieldChange={onFieldChange}
                    onDeleteMilestone={onDeleteMilestone}
                    loading={loading}
                    onSubmit={onSubmit}
                    onCancel={onCancel}
                    onBack={goBack}
                    component={StepMilestonesFrom}
                  />
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Grid>
    </React.Fragment>
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StepMilestonesFormContainer);
